import { useMemo } from 'react'
import { useGetCourseAuthorsQuery } from '@services/courseAuthors'
import { Option } from '@organisms/Select'
import { Field } from '@templates/AddNewItemModal/Content'
import selectField, {
  SelectFieldParams,
} from '@templates/AddNewItemModal/templates/selectField'

const useCourseAuthorsSelectField = (): ((
  params: Omit<SelectFieldParams, 'options'> & { name: string; label: string }
) => Field) => {
  const { data: courseAuthors = [], isLoading } = useGetCourseAuthorsQuery()
  const options = useMemo<Option[]>(
    () =>
      courseAuthors.map((author) => ({
        label: author.name,
        value: author.id,
      })),
    [courseAuthors]
  )

  return (params) =>
    selectField({
      ...params,
      options,
      isLoading,
      withoutFetchOptions: true,
    })
}

export default useCourseAuthorsSelectField
